import { AUTH_ACTION_TYPES } from '../actions/types';

// Initial state for authentication
const initialState = {
  // User data
  user: null,
  accessToken: null,
  userType: null,
  userId: null,
  
  // Authentication status
  isAuthenticated: false,
  isLoading: false,
  
  // Error handling
  error: null,
  errorStatus: null,
  
  // Success messages
  successMessage: null,
  
  // Specific action states
  loginLoading: false,
  registerLoading: false,
  logoutLoading: false,
  forgotPasswordLoading: false,
  resetPasswordLoading: false,
  verifyEmailLoading: false,
  checkUsernameLoading: false,
  
  // Username check state
  usernameCheckResult: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    // Login actions
    case AUTH_ACTION_TYPES.LOGIN_REQUEST:
      return {
        ...state,
        loginLoading: true,
        isLoading: true,
        error: null,
        errorStatus: null,
        successMessage: null,
      };

    case AUTH_ACTION_TYPES.LOGIN_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        isLoading: false,
        isAuthenticated: true,
        user: action.payload.user,
        accessToken: action.payload.accessToken,
        userType: action.payload.userType,
        userId: action.payload.user?.id || null,
        successMessage: action.payload.message,
        error: null,
        errorStatus: null,
      };

    case AUTH_ACTION_TYPES.LOGIN_FAILURE:
      return {
        ...state,
        loginLoading: false,
        isLoading: false,
        isAuthenticated: false,
        user: null,
        accessToken: null,
        userType: null,
        userId: null,
        error: action.payload.error,
        errorStatus: action.payload.status,
        successMessage: null,
      };

    // Register actions
    case AUTH_ACTION_TYPES.REGISTER_REQUEST:
      return {
        ...state,
        registerLoading: true,
        isLoading: true,
        error: null,
        errorStatus: null,
        successMessage: null,
      };

    case AUTH_ACTION_TYPES.REGISTER_SUCCESS:
      return {
        ...state,
        registerLoading: false,
        isLoading: false,
        user: action.payload.user,
        successMessage: action.payload.message,
        error: null,
        errorStatus: null,
      };

    case AUTH_ACTION_TYPES.REGISTER_FAILURE:
      return {
        ...state,
        registerLoading: false,
        isLoading: false,
        error: action.payload.error,
        errorStatus: action.payload.status,
        successMessage: null,
      };

    // Logout actions
    case AUTH_ACTION_TYPES.LOGOUT_REQUEST:
      return {
        ...state,
        logoutLoading: true,
        isLoading: true,
        error: null,
        errorStatus: null,
        successMessage: null,
      };

    case AUTH_ACTION_TYPES.LOGOUT_SUCCESS:
      return {
        ...state,
        logoutLoading: false,
        isLoading: false,
        isAuthenticated: false,
        user: null,
        accessToken: null,
        userType: null,
        userId: null,
        successMessage: action.payload.message,
        error: null,
        errorStatus: null,
      };

    case AUTH_ACTION_TYPES.LOGOUT_FAILURE:
      return {
        ...state,
        logoutLoading: false,
        isLoading: false,
        error: action.payload.error,
        errorStatus: action.payload.status,
        successMessage: null,
      };


    // Forgot password actions
    case AUTH_ACTION_TYPES.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPasswordLoading: true,
        isLoading: true,
        error: null,
        errorStatus: null,
        successMessage: null,
      };

    case AUTH_ACTION_TYPES.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordLoading: false,
        isLoading: false,
        successMessage: action.payload.message,
        error: null,
        errorStatus: null,
      };

    case AUTH_ACTION_TYPES.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPasswordLoading: false,
        isLoading: false,
        error: action.payload.error,
        errorStatus: action.payload.status,
        successMessage: null,
      };

    // Reset password actions
    case AUTH_ACTION_TYPES.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordLoading: true,
        isLoading: true,
        error: null,
        errorStatus: null,
        successMessage: null,
      };

    case AUTH_ACTION_TYPES.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        isLoading: false,
        successMessage: action.payload.message,
        error: null,
        errorStatus: null,
      };

    case AUTH_ACTION_TYPES.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordLoading: false,
        isLoading: false,
        error: action.payload.error,
        errorStatus: action.payload.status,
        successMessage: null,
      };

    // Email verification actions
    case AUTH_ACTION_TYPES.VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        verifyEmailLoading: true,
        isLoading: true,
        error: null,
        errorStatus: null,
        successMessage: null,
      };

    case AUTH_ACTION_TYPES.VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        verifyEmailLoading: false,
        isLoading: false,
        successMessage: action.payload.message,
        error: null,
        errorStatus: null,
      };

    case AUTH_ACTION_TYPES.VERIFY_EMAIL_FAILURE:
      return {
        ...state,
        verifyEmailLoading: false,
        isLoading: false,
        error: action.payload.error,
        errorStatus: action.payload.status,
        successMessage: null,
      };

    // Username check actions
    case AUTH_ACTION_TYPES.CHECK_USERNAME_REQUEST:
      return {
        ...state,
        checkUsernameLoading: true,
        isLoading: true,
        error: null,
        errorStatus: null,
        usernameCheckResult: null,
      };

    case AUTH_ACTION_TYPES.CHECK_USERNAME_SUCCESS:
      return {
        ...state,
        checkUsernameLoading: false,
        isLoading: false,
        usernameCheckResult: {
          username: action.payload.username,
          isAvailable: action.payload.isAvailable,
          message: action.payload.message,
        },
        error: null,
        errorStatus: null,
      };

    case AUTH_ACTION_TYPES.CHECK_USERNAME_FAILURE:
      return {
        ...state,
        checkUsernameLoading: false,
        isLoading: false,
        usernameCheckResult: null,
        error: action.payload.error,
        errorStatus: action.payload.status,
      };

    // General auth actions
    case AUTH_ACTION_TYPES.CLEAR_AUTH_ERRORS:
      return {
        ...state,
        error: null,
        errorStatus: null,
        successMessage: null,
      };

    case AUTH_ACTION_TYPES.SET_AUTH_STATUS:
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
      };

    default:
      return state;
  }
};

export default authReducer;
